module.exports = __webpack_public_path__ + "static/media/18_Account_Demographic Info.c67cba37.jpg";